// import { createBrowserHistory } from 'history';
import { useHistory } from 'react-router-dom';

export default function (props: Props) {
    // const history = useHistory();
    return useHistory();
}

// export default createBrowserHistory();
// export default history;